import angular from 'angular';
import _ from 'lodash';
import ChangeIdFormInfo from './change-id-form-info.data';

(function() {
  'use strict';
  angular.module('app.core').factory('SellerBo', SellerBoData);

  SellerBoData.$inject = ['$translate', 'Seller', 'User', 'SellerPrincipal', 'PrincipalDetail'];

  /* @ngInject */
  function SellerBoData($translate, Seller, User, SellerPrincipal, PrincipalDetail) {
    SellerBo.prototype = {
      build: build,
      buildEmpty: buildEmpty
    };

    function SellerBo(sellerBoData) {
      if (!sellerBoData) {
        this.buildEmpty();
      } else {
        this.build(sellerBoData);
      }
    }

    return SellerBo;

    /////////////////////

    function buildEmpty() {
      this.seller = new Seller();
      this.changeIdFormInfo = new ChangeIdFormInfo();
      this.users = [];
      this.principalEntity = new PrincipalDetail();
    }

    function build(sellerBoData) {
      this.seller = new Seller(sellerBoData.seller);
      this.changeIdFormInfo = sellerBoData.changeIdFormInfo
        ? new ChangeIdFormInfo(sellerBoData.changeIdFormInfo, $translate)
        : null;
      this.users = {
        totalItems: sellerBoData.users.length,
        items: _.map(sellerBoData.users, function(u) {
          return new User(u);
        })
      };
      this.principal = {
        totalItems: sellerBoData.principalRelations.length,
        items: _.map(sellerBoData.principalRelations, function(p) {
          return new SellerPrincipal(p);
        })
      };
      this.principalEntity = new PrincipalDetail(sellerBoData.principal);
    }
  }
})();
